import { useTranslation } from 'react-i18next'
import RozmowaForm from '../common/components/RozmowaForm'
import useRozmowaAddPage from './hooks/useRozmowaAddPage'

export default function RozmowaAdd() {
	const { t } = useTranslation()
	const {
		form,
		handleCancel,
		handleChange,
		handleClearPlacowka,
		handleNewOsobaChange,
		handleOsobaModeChange,
		handleSelectOsoba,
		handleSelectPlacowka,
		handleSubmit,
		loadingOsoby,
		newOsoba,
		osobaMode,
		osoby,
		osobyError,
		selectedPlacowka,
		submitting,
	} = useRozmowaAddPage()

	return (
		<div className="max-w-6xl mx-auto px-0 sm:px-6 lg:px-8">
			<div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
				<div className="px-4 sm:px-6 py-6 border-b border-gray-200">
					<h1 className="text-2xl font-bold text-gray-900">{t('conversations.add.title')}</h1>
				</div>

				<div className="px-4 sm:px-6 py-6">
					<RozmowaForm
						mode="add"
						form={form}
						onCancel={handleCancel}
						onChange={handleChange}
						onClearPlacowka={handleClearPlacowka}
						onNewOsobaChange={handleNewOsobaChange}
						onOsobaModeChange={handleOsobaModeChange}
						onSelectOsoba={handleSelectOsoba}
						onSelectPlacowka={handleSelectPlacowka}
						onSubmit={handleSubmit}
						loadingOsoby={loadingOsoby}
						newOsoba={newOsoba}
						osobaMode={osobaMode}
						osoby={osoby}
						osobyError={osobyError}
						selectedPlacowka={selectedPlacowka}
						submitting={submitting}
					/>
				</div>
			</div>
		</div>
	)
}
